import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Plan from './plan'
import { LANDING_PAGE_WIDTH, MIN_DESKTOP_THRESHOLD } from '~/core/constants'

const PlanContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ size }) => size}, 1fr);
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  width: 100%;

  @media screen and (min-width: ${MIN_DESKTOP_THRESHOLD}) {
    width: ${LANDING_PAGE_WIDTH};
    overflow: visible;
    margin-left: 8px;
  }
`

const Plans = ({ items, activePlan, popularPlan, popularText, selectPlan }) => (
  <PlanContainer size={items.length}>
    {items.map((item, i) => (
      <Plan
        {...item}
        key={item.id}
        costLimit={items[items.length - 1].totalCost}
        isActive={item === activePlan}
        isPopular={item === popularPlan}
        index={i}
        popularText={popularText}
        selectPlan={selectPlan}
      />
    ))}
  </PlanContainer>
)

const PlanType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  currency: PropTypes.string,
  overage: PropTypes.string,
  price: PropTypes.string,
  interval: PropTypes.string
})

Plans.propTypes = {
  items: PropTypes.arrayOf(PlanType),
  activePlan: PlanType,
  popularPlan: PlanType,
  popularText: PropTypes.string,
  selectPlan: PropTypes.func
}

export default Plans
